import React from "react";
import { Fab } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { AnimatePresence, motion, useScroll } from "framer-motion";

const MotionFab = motion(Fab);

export default function ScrollToTopButton({
  threshold = 250,
  bottom = 24,
  right = 24,
}) {
  const { scrollY } = useScroll();
  const [show, setShow] = React.useState(false);

  // Hysteresis to prevent rapid toggling near the threshold
  const SHOW_AT = threshold;
  const HIDE_AT = Math.max(0, threshold - 80);

  React.useEffect(() => {
    let ticking = false;
    const unsub = scrollY.on("change", (y) => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setShow((prev) => (prev ? y > HIDE_AT : y > SHOW_AT));
        ticking = false;
      });
    });
    return () => unsub();
  }, [scrollY, SHOW_AT, HIDE_AT]);

  const goTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <AnimatePresence initial={false}>
      {show && (
        <MotionFab
          // no key here to avoid remount flicker
          onClick={goTop}
          aria-label="Scroll to top"
          initial={{ opacity: 0, y: 16, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 12, scale: 0.98 }}
          transition={{ duration: 0.22, ease: "easeOut" }}
          sx={{
            position: "fixed",
            bottom: `calc(${bottom}px + env(safe-area-inset-bottom, 0px))`,
            right: `calc(${right}px + env(safe-area-inset-right, 0px))`,
            zIndex: (t) => t.zIndex.tooltip + 1,
            boxShadow: 10,
            background: "#0B8282",
            color: "white",
            // smooth hover without layout thrash
            transition: "transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease, color 0.25s ease",
            willChange: "transform, opacity",
            backfaceVisibility: "hidden",
            transform: "translateZ(0)",
            border:'2px solid white',
            "&:hover": {
              background: "white",
              color: "#0B8282",
              boxShadow: "0px 10px 24px rgba(0,0,0,0.25)",
              transform: "translateZ(0) scale(1.08)",
              border:'2px solid #0B8282'
            },
          }}
        >
          <ArrowUpwardIcon />
        </MotionFab>
      )}
    </AnimatePresence>
  );
}
